export const upgradeTracks = [
  'Myth',
  'Hero',
  'Champion',
  'Veteran',
  'Adventurer',
  'Explorer',
  'None',
] as const

export const upgradeTrackToDifficulty: Record<UpgradeTrack, string> = {
  Myth: 'mythic',
  Hero: 'heroic',
  Champion: 'normal',
  Veteran: 'raid_finder',
  Adventurer: 'world_advanced',
  Explorer: 'world_basic',
  None: '',
} as const

export const colorByTrack: Record<UpgradeTrack, string> = {
  Myth: 'text-quality-legendary',
  Hero: 'text-quality-epic',
  Champion: 'text-quality-rare',
  Veteran: 'text-quality-uncommon',
  Adventurer: 'text-quality-uncommon',
  Explorer: 'text-quality-uncommon',
  None: 'text-foreground',
} as const

type UpgradeTrack = typeof upgradeTracks[number]
export default UpgradeTrack
